<template>
    <div v-if="!loading">
        <div class="text-right mb-4">
            <button :class="'btn btn-primary ' + (esMovil ? 'w-100' : '')" @click.prevent="guardarPrecios(zonas)">Guardar todos</button>
        </div>
        <template v-for="(zona, index) in zonas">
            <div class="row align-items-center mb-4" :key="index">
                <div class="col-12 col-md-10">
                    <div class="row">
                        <div class="col-12 col-md-2 mb-2 mt-2 mb-md-0">
                            <strong>{{ zona.nombre }}</strong>
                        </div>
                        <div class="col-12 col-md-5">
                            <label for="precio_taquilla" v-if="index === 0">Precio Taquilla:</label>
                            <multiselect
                                v-model="zona.precios_taquilla"
                                placeholder="Precios taquilla"
                                :custom-label="customLabel"
                                label="label_con_gd"
                                track-by="id"
                                :options="tipos.data"
                                :multiple="true"
                                :show-labels="false"
                                @select="change($event, index, true)"
                                class="mb-2 mb-md-0"
                            />
                        </div>
                        <div class="col-12 col-md-5">
                            <label for="precios_online" v-if="index === 0">Precios Online:</label>
                            <multiselect
                                v-model="zona.precios_online"
                                placeholder="Precios online"
                                :custom-label="customLabel"
                                label="label_sin_gd"
                                track-by="id"
                                :options="tipos.data"
                                :multiple="true"
                                :show-labels="false"
                                @select="change($event, index, false)"
                                class="mb-2 mb-md-0"
                            />
                        </div>
                    </div>
                    <div v-if="esMovil" class="col-12 text-right p-0">
                        <button class="btn btn-primary w-100" @click.prevent="guardarPrecios([zona])">Guardar</button>
                    </div>
                </div>
                <div v-if="!esMovil" class="col-2 text-right">
                    <Button @click.prevent="guardarPrecios([zona])">Guardar</Button>
                </div>
            </div>
        </template>
    </div>
    <div v-else>
        <div class="card-body">
            <LoaderComponent/>
        </div>
    </div>
</template>

<script>
    import LoaderComponent from '@/components/preloader/LoaderComponent';

    export default {
        props: ['tipos', 'place_id', 'esMovil'],
        data() {
            return {
                zonas: [],
                loading: false
            }
        },
        created() {
            if(this.place_id) {
                this.getZonas();
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            permisos() {
                return this.$store.getters.getPermisos;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
        },
        methods: {
            change(selectedOption, index, taquilla) {
                if (!this.ambos) return

                const zona = this.zonas[index]
                const precios = taquilla
                    ? zona.precios_online
                    : zona.precios_taquilla

                precios.push(selectedOption)
            },
            getZonas : function() {
                this.loading = true;

                var filters = {
                    per_page: 10,
                    page: 1,
                    search: '',
                    all: 1,
                    place_id: this.place_id
                };

                const params = {
                    filters : filters,
                    lista_id: this.$store.getters.getListaId,
                    place_id: this.place_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.precios.zonas'), params).then(res => {
                    this.zonas = res.data.zonas;
                    for(var i in this.zonas) {
                        this.setPrecios(i);
                    }
                    this.loading = false;
                });
            },
            setPrecios(index) {
                for(var x in this.zonas[index]['precios_online']) {
                    for(var e in this.tipos.data) {
                        if(this.tipos.data[e].id == this.zonas[index]['precios_online'][x]) {
                            this.zonas[index]['precios_online'][x] = this.tipos.data[e];
                        }
                    }
                }

                for(var j in this.zonas[index]['precios_taquilla']) {
                    for(var z in this.tipos.data) {
                        if(this.tipos.data[z].id == this.zonas[index]['precios_taquilla'][j]) {
                            this.zonas[index]['precios_taquilla'][j] = this.tipos.data[z];
                        }
                    }
                }
            },
            guardarPrecios(zonas) {
                this.loading = true;

                for (var i in zonas) {
                    var precios_online = []
                    var precios_taquilla = []

                    for (var x in zonas[i].precios_online) {
                        precios_online.push(zonas[i].precios_online[x].id)
                    }

                    for (var z in zonas[i].precios_taquilla) {
                        precios_taquilla.push(zonas[i].precios_taquilla[z].id)
                    }

                    zonas[i].precios_online = precios_online
                    zonas[i].precios_taquilla = precios_taquilla
                }
                const params = {
                    filters : {
                    },
                    data: zonas,
                    lista_id: this.$store.getters.getListaId
                }

                this.$store.dispatch(this.config.getVuexAlias('back.precios.zonas.editar'), params).then(res => {
                    this.zonas = res.data;
                    this.getZonas();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                }).finally(() => this.loading = false);
            },
            customLabel({ descripcion, renovacion }) {
                if(renovacion) {
                    return '(Renovación) - ' + `${descripcion}`;
                }

                return `${descripcion}`
            }
        },
        components: {
            LoaderComponent
        }
    }
</script>
